import { useContext } from 'react';

import {
  ErrorContext,
  ErrorContextValues,
} from '../../context/error-context/error-context';

export const useErrorContext = (): ErrorContextValues => {
  const context = useContext(ErrorContext);

  if (!context) {
    throw new Error('No provider found for Error Context');
  }

  return context;
};
